/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { Badge } from "reactstrap";

import { openCountsByCategory } from "../signalFiltering";
import { CATEGORY_COLOR, CATEGORY_LABEL, Signal, SignalCategory, SignalCategoryList } from "../signalTypes";

interface SignalsBannerProps {
    signals: Signal[];
    onCategoryClick: (category: SignalCategory) => void;
    className?: string;
}

/** Room-detail summary banner: per-category open-signal counts. Hidden when
 *  the room has no open signals. Clicking a category opens the Signals tab
 *  pre-filtered to it (R15). */
export const SignalsBanner: React.FC<SignalsBannerProps> = ({ signals, onCategoryClick, className = "mb-3" }) => {
    const counts = openCountsByCategory(signals);
    if (counts.total === 0) return null;

    return (
        <div className={`d-flex flex-wrap align-items-center gap-2 ${className}`.trim()}>
            <span className="fw-bold small text-muted">Open signals:</span>
            {SignalCategoryList.map((category) => (counts[category] > 0 ? (
                <Badge
                    key={category}
                    role="button"
                    color={CATEGORY_COLOR[category]}
                    onClick={() => onCategoryClick(category)}
                    css={css`cursor: pointer;`}
                >
                    {CATEGORY_LABEL[category]}: {counts[category]}
                </Badge>
            ) : null),)}
        </div>
    );
};

export default SignalsBanner;
